import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import { SecurityService } from '../Security/SecurityService';
import { VisualActions } from "../../../models/const.Contants";

@Directive({
    selector: '[visualActionUnauthorized]',
    standalone: false
})
export class VisualActionUnauthorizedDirective implements OnInit {
  @Input('permission') permission: string; 
  @Input('action') action: string; 
  constructor(private el: ElementRef, private securityService: SecurityService) { }

  ngOnInit() {
    if (!this.securityService.userHasPermission(this.permission)) {
      if (VisualActions.hide == this.action) {
        this.el.nativeElement.style.display = 'none';
      }
      else if (VisualActions.disable == this.action) {
        this.el.nativeElement.disabled = true;
      }
      else if (VisualActions.readonly == this.action) {
        this.el.nativeElement.setAttribute('readonly', true);
      }
    }
  }
}
